import React, { useState } from "react";
import { Container, Nav, Navbar, Row, Col } from "react-bootstrap";
import { NavLink, Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import {
  FaMapMarkerAlt,
  FaStore,
  FaPhoneAlt,
  FaWhatsapp,
  FaShoppingCart,
  FaBars,
  FaTimes,
  FaFilePdf,
  FaDownload,
} from "react-icons/fa";

const AppBar = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      {/* ========================================================
          DESKTOP HEADER (Visible on lg and above)
          ======================================================== */}
      <div className="d-none d-lg-block">
        {/* Top Banner & Marquee Bar */}
        <div className="mark-bg border-bottom border-dark">
          <Container>
            <Row className="py-2 align-items-center">
              <Col lg="4" className="d-flex align-items-center">
                <div className="gpay-top-pill d-flex align-items-center bg-white px-2 py-1 rounded-pill shadow-sm">
                  <img
                    src={require("../../assets/images/gpay.png")}
                    className="img-fluid"
                    alt="Google Pay"
                    style={{ width: "65px", height: "auto" }}
                  />
                  <div className="text-dark ms-2 ps-2 border-start border-secondary-subtle">
                    <span className="small text-muted d-block" style={{ fontSize: "10.5px", lineHeight: 1 }}>
                      UPI / GPay No:
                    </span>
                    <strong className="bold text-danger" style={{ fontSize: "13.5px" }}>
                      9498402615
                    </strong>
                  </div>
                </div>
              </Col>
              <Col lg="8" className="text-white">
                <Marquee pauseOnHover={true} direction="left" speed={55} delay={3}>
                  <span className="bold text-warning mx-2">💥 DIWALI SPECIAL 80% FLAT DISCOUNT! 💥</span>
                  <span className="mx-2 text-white-50">|</span>
                  <span className="bold mx-2">💬 WhatsApp: +91 98430 58048</span>
                  <span className="mx-2 text-white-50">|</span>
                  <span className="bold mx-2">📞 Call: +91 73588 66226 / +91 99768 58631</span>
                  <span className="mx-2 text-white-50">|</span>
                  <span className="bold mx-2">✉️ Email: gmrcrackers@gmail.com</span>
                  <span className="mx-2 text-white-50">|</span>
                  <span className="bold text-info mx-2">🚚 Sivakasi Direct Factory Dispatch</span>
                </Marquee>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Desktop Main Header with Logo & Contact Columns */}
        <div className="navv-bg bg-white shadow-sm border-bottom">
          <Container className="py-2">
            <Row className="align-items-center">
              {/* Logo */}
              <Col lg="3" className="text-start py-1">
                <Navbar.Brand as={Link} to="/" className="d-inline-block p-0 m-0">
                  <img
                    src={require("../../assets/images/banner/logo.png")}
                    className="img-fluid desktop-header-logo"
                    alt="GMR Crackers Sivakasi"
                    style={{ height: "85px", width: "auto", objectFit: "contain" }}
                  />
                </Navbar.Brand>
              </Col>

              {/* Factory Address */}
              <Col lg="3" className="py-1">
                <div className="d-flex align-items-start gap-2">
                  <div className="header-icon-box bg-danger-subtle text-danger p-2 rounded-circle mt-1">
                    <FaMapMarkerAlt size={18} />
                  </div>
                  <div>
                    <h6 className="bold text-dark mb-0" style={{ fontSize: "13.5px" }}>
                      Factory & Shop
                    </h6>
                    <p className="regular text-muted mb-0 lh-sm" style={{ fontSize: "11.5px" }}>
                      D. No: 3/347c1/1, Maraneri, Sivakasi to Alangulam Main Road, Singampatti, Sivakasi - 626124
                    </p>
                  </div>
                </div>
              </Col>

              {/* Chennai Branch */}
              <Col lg="3" className="py-1">
                <div className="d-flex align-items-start gap-2">
                  <div className="header-icon-box bg-primary-subtle text-primary p-2 rounded-circle mt-1">
                    <FaStore size={18} />
                  </div>
                  <div>
                    <h6 className="bold text-dark mb-0" style={{ fontSize: "13.5px" }}>
                      Chennai Branch
                    </h6>
                    <p className="regular text-muted mb-0 lh-sm" style={{ fontSize: "11.5px" }}>
                      Rudhra Maya Crackers Shop, 8A, Kannadapalayam, Vellanur, Avadi, Chennai - 62
                    </p>
                  </div>
                </div>
              </Col>

              {/* Mobile Numbers */}
              <Col lg="3" className="py-1">
                <div className="d-flex align-items-start gap-2">
                  <div className="header-icon-box bg-success-subtle text-success p-2 rounded-circle mt-1">
                    <FaPhoneAlt size={18} />
                  </div>
                  <div>
                    <h6 className="bold text-dark mb-0" style={{ fontSize: "13.5px" }}>
                      Call / WhatsApp
                    </h6>
                    <div className="regular text-muted small lh-sm">
                      <a href="tel:+919843058048" className="text-decoration-none text-dark fw-bold d-block hover-danger">
                        +91 98430 58048
                      </a>
                      <a
                        href="tel:+917358866226"
                        className="text-decoration-none text-muted d-inline-block me-2 hover-danger"
                        style={{ fontSize: "12px" }}
                      >
                        +91 73588 66226
                      </a>
                      <a
                        href="tel:+919976858631"
                        className="text-decoration-none text-muted d-inline-block hover-danger"
                        style={{ fontSize: "12px" }}
                      >
                        +91 99768 58631
                      </a>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        {/* Desktop Sticky Navigation Bar */}
        <Navbar expand="lg" className="navlinkContainer-bg sticky-top shadow py-0">
          <Container>
            <Nav className="me-auto py-2 align-items-center">
              <Nav.Link className="nav-item-link text-white bold px-3 py-2" as={NavLink} to="/home">
                Home
              </Nav.Link>
              <Nav.Link className="nav-item-link text-white bold px-3 py-2" as={NavLink} to="/about">
                About Us
              </Nav.Link>
              <Nav.Link
                className="nav-item-link blink-highlight bold px-3 py-2"
                as={NavLink}
                to="/"
              >
                💥 Price List (80% Off)
              </Nav.Link>
              <Nav.Link className="nav-item-link text-white bold px-3 py-2" as={NavLink} to="/safetytips">
                Safety Tips
              </Nav.Link>
              <Nav.Link className="nav-item-link text-white bold px-3 py-2" as={NavLink} to="/contact">
                Contact Us
              </Nav.Link>
              <Nav.Link
                className="nav-item-link blink-highlight bold px-3 py-2"
                as={NavLink}
                to="/chitsfunds"
              >
                ✨ Chit Funds
              </Nav.Link>
            </Nav>

            {/* Action Buttons: Download Price List 2026 + Quick Order */}
            <div className="py-2 d-flex align-items-center gap-2">
              <a
                href="/gmr_crackers_pricelist_2026.pdf"
                download="GMR_Crackers_Price_List_2026.pdf"
                className="btn btn-warning btn-sm rounded-pill px-3 py-2 bold d-flex align-items-center gap-2 shadow-sm download-nav-btn"
                title="Download Official 2026 Price List PDF (80% Off)"
              >
                <FaFilePdf className="text-danger" size={15} />
                <span>Price List 2026</span>
                <FaDownload className="download-bounce-icon" size={11} />
              </a>

              <Link
                to="/"
                className="btn btn-danger btn-sm rounded-pill px-3 py-2 bold d-flex align-items-center gap-2 shadow-sm"
              >
                <FaShoppingCart size={14} /> Quick Order / Estimate
              </Link>
            </div>
          </Container>
        </Navbar>
      </div>

      {/* ========================================================
          MOBILE HEADER (Sticky, Compact, Unified, Modern)
          ======================================================== */}
      <div className="d-lg-none sticky-top mobile-header-wrapper shadow-sm">
        {/* Slim Festive Marquee */}
        <div className="mobile-top-marquee py-1 text-white">
          <Marquee pauseOnHover={true} direction="left" speed={45}>
            <span className="bold text-warning mx-2" style={{ fontSize: "12px" }}>
              💥 DIWALI SPECIAL 80% FLAT DISCOUNT!
            </span>
            <span className="mx-2 text-white-50">|</span>
            <span className="mx-2 text-white" style={{ fontSize: "12px" }}>
              🚚 Sivakasi Direct Factory Dispatch
            </span>
            <span className="mx-2 text-white-50">|</span>
            <span className="text-info mx-2 bold" style={{ fontSize: "12px" }}>
              📞 +91 98430 58048
            </span>
          </Marquee>
        </div>

        {/* Clean Unified Mobile Header Bar */}
        <div className="mobile-header-bar px-3 py-2 d-flex align-items-center justify-content-between border-bottom">
          {/* Brand Logo */}
          <Link
            to="/"
            onClick={() => setMobileNavOpen(false)}
            className="d-inline-flex align-items-center text-decoration-none"
          >
            <img
              src={require("../../assets/images/banner/logo.png")}
              className="img-fluid mobile-logo-img"
              alt="GMR Crackers Sivakasi"
              style={{ height: "54px", width: "auto", objectFit: "contain" }}
            />
          </Link>

          {/* Quick Contact & Menu Toggle */}
          <div className="d-flex align-items-center gap-2">
            <a
              href="https://wa.me/919843058048?text=Hello%20GMR%20Crackers,%20I%20want%20to%20order%20crackers"
              target="_blank"
              rel="noopener noreferrer"
              className="mobile-action-circle bg-success text-white"
              title="Chat on WhatsApp"
            >
              <FaWhatsapp size={20} />
            </a>

            <a
              href="tel:+919843058048"
              className="mobile-action-circle bg-primary text-white"
              title="Call Us"
            >
              <FaPhoneAlt size={16} />
            </a>

            <button
              type="button"
              onClick={() => setMobileNavOpen(!mobileNavOpen)}
              className="mobile-action-circle btn btn-light border p-0 ms-1"
              aria-label="Toggle navigation menu"
            >
              {mobileNavOpen ? <FaTimes size={18} className="text-dark" /> : <FaBars size={18} className="text-dark" />}
            </button>
          </div>
        </div>

        {/* Collapsible Mobile Navigation Drawer */}
        {mobileNavOpen && (
          <div className="mobile-nav-drawer text-white">
            <div className="d-flex flex-column gap-2">
              <a
                href="/gmr_crackers_pricelist_2026.pdf"
                download="GMR_Crackers_Price_List_2026.pdf"
                onClick={() => setMobileNavOpen(false)}
                className="btn btn-warning w-100 rounded-pill bold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2 download-nav-btn"
              >
                <FaFilePdf className="text-danger" size={16} />
                <span>Download Price List 2026 (PDF)</span>
                <FaDownload className="download-bounce-icon" size={13} />
              </a>

              <Link
                to="/"
                onClick={() => setMobileNavOpen(false)}
                className="mobile-price-btn text-center bold py-2 px-3 rounded-pill text-dark d-block shadow-sm"
              >
                💥 Price List (80% Off)
              </Link>

              <Link
                to="/chitsfunds"
                onClick={() => setMobileNavOpen(false)}
                className="btn btn-warning text-dark bold py-2 px-3 rounded-pill d-block text-center shadow-sm"
                style={{
                  background: "linear-gradient(135deg, #ffd700 0%, #ffae19 100%)",
                  border: "1px solid rgba(255, 255, 255, 0.6)",
                }}
              >
                ✨ Diwali Chit Funds
              </Link>

              <div className="my-1 border-top border-white-50"></div>

              <NavLink
                to="/home"
                onClick={() => setMobileNavOpen(false)}
                className="mobile-drawer-link"
              >
                🏠 Home
              </NavLink>
              <NavLink
                to="/about"
                onClick={() => setMobileNavOpen(false)}
                className="mobile-drawer-link"
              >
                ℹ️ About Us
              </NavLink>
              <NavLink
                to="/safetytips"
                onClick={() => setMobileNavOpen(false)}
                className="mobile-drawer-link"
              >
                🛡️ Safety Tips
              </NavLink>
              <NavLink
                to="/contact"
                onClick={() => setMobileNavOpen(false)}
                className="mobile-drawer-link"
              >
                📍 Contact Us
              </NavLink>

              <div className="my-1 border-top border-white-50"></div>

              <Link
                to="/"
                onClick={() => setMobileNavOpen(false)}
                className="btn btn-danger w-100 rounded-pill bold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2"
              >
                <FaShoppingCart size={15} /> Quick Order / Estimate
              </Link>

              {/* Quick Branch Location Info in Drawer */}
              <div className="p-2 bg-white rounded-3 text-dark mt-2 shadow-sm">
                <div className="d-flex align-items-start gap-2 mb-1">
                  <FaMapMarkerAlt className="text-danger flex-shrink-0 mt-1" size={13} />
                  <span style={{ fontSize: "11px", lineHeight: "1.3" }}>
                    <strong>Factory:</strong> Maraneri, Sivakasi to Alangulam Main Rd, Sivakasi
                  </span>
                </div>
                <div className="d-flex align-items-start gap-2">
                  <FaStore className="text-primary flex-shrink-0 mt-1" size={13} />
                  <span style={{ fontSize: "11px", lineHeight: "1.3" }}>
                    <strong>Chennai:</strong> Rudhra Maya, Avadi - 62
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AppBar;
